export class ClinicalData {
  date: string;
  value: string;
  dateInput: string;

  constructor(date: string, value: string, dateInput: string) {
    this.date = date;
    this.value = value;
    this.dateInput = dateInput;
  }
}
